import { cn } from "@/lib/utils";
import type { LegalRoleFilter as LegalRoleFilterValue } from "@/content/legal/legal-types";

const ROLE_OPTIONS: { value: LegalRoleFilterValue; label: string }[] = [
  { value: "ALL", label: "Todos" },
  { value: "MOTOBOY", label: "Motoboy" },
  { value: "LOJISTA", label: "Lojista" },
  { value: "SUB_LOJISTA", label: "Sub Lojista" },
];

type LegalRoleFilterProps = {
  selectedRole: LegalRoleFilterValue;
  onSelectRole: (role: LegalRoleFilterValue) => void;
};

function LegalRoleFilter({ selectedRole, onSelectRole }: LegalRoleFilterProps) {
  return (
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">
        Filtrar por perfil
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        {ROLE_OPTIONS.map((option) => {
          const isSelected = selectedRole === option.value;

          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={isSelected}
              onClick={() => onSelectRole(option.value)}
              className={cn(
                "rounded-full border px-3.5 py-1.5 text-xs font-semibold transition-colors",
                isSelected
                  ? "border-primary bg-primary/10 text-primary"
                  : "border-border bg-transparent text-foreground/70 hover:border-primary/40 hover:text-foreground",
              )}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { LegalRoleFilter };
